import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=70a94378&scoped=true&"
import script from "./PropertyEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PropertyEdit.vue?vue&type=style&index=0&id=70a94378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a94378",
  null
  
)

export default component.exports